export enum MarketTypes {
  CLEAR_FILTER = '@market/CLEAR_FILTER',
  CHANGE_VALUE = '@market/CHANGE_VALUE',
  SEARCH_REQUEST = '@market/SEARCH_REQUEST',
  SEARCH_SUCCESS = '@market/SEARCH_SUCCESS',
  SEARCH_FAILURE = '@market/SEARCH_FAILURE',
  GET_FILTERS_REQUEST = '@market/GET_FILTERS_REQUEST',
  GET_FILTERS_SUCCESS = '@market/GET_FILTERS_SUCCESS',
  GET_FILTERS_FAILURE = '@market/GET_FILTERS_FAILURE',
  SEARCH_BUYERS_REQUEST = '@market/SEARCH_BUYERS_REQUEST',
  SEARCH_BUYERS_SUCCESS = '@market/SEARCH_BUYERS_SUCCESS',
  SEARCH_BUYERS_FAILURE = '@market/SEARCH_BUYERS_FAILURE',
  SEARCH_PROVIDERS_REQUEST = '@market/SEARCH_PROVIDERS_REQUEST',
  SEARCH_PROVIDERS_SUCCESS = '@market/SEARCH_PROVIDERS_SUCCESS',
  SEARCH_PROVIDERS_FAILURE = '@market/SEARCH_PROVIDERS_FAILURE',
  GET_FILTER_OPTIONS_REQUEST = '@market/GET_FILTER_OPTIONS_REQUEST',
  GET_FILTER_OPTIONS_SUCCESS = '@market/GET_FILTER_OPTIONS_SUCCESS',
  GET_FILTER_OPTIONS_FAILURE = '@market/GET_FILTER_OPTIONS_FAILURE',
  GET_PUBLIC_BODY_REQUEST = '@market/GET_PUBLIC_BODY_REQUEST',
  GET_PUBLIC_BODY_SUCCESS = '@market/GET_PUBLIC_BODY_SUCCESS',
  GET_PUBLIC_BODY_FAILURE = '@market/GET_PUBLIC_BODY_FAILURE',
  GET_BIDDINGS_REQUEST = '@market/GET_BIDDINGS_REQUEST',
  GET_BIDDINGS_SUCCESS = '@market/GET_BIDDINGS_SUCCESS',
  GET_BIDDINGS_FAILURE = '@market/GET_BIDDINGS_FAILURE',
  GET_COMPANY_DATA_REQUEST = '@market/GET_COMPANY_DATA_REQUEST',
  GET_COMPANY_DATA_SUCCESS = '@market/GET_COMPANY_DATA_SUCCESS',
  GET_COMPANY_DATA_FAILURE = '@market/GET_COMPANY_DATA_FAILURE',
  GET_PROVIDER_BIDDINGS_REQUEST = '@market/GET_PROVIDER_BIDDINGS_REQUEST',
  GET_PROVIDER_BIDDINGS_SUCCESS = '@market/GET_PROVIDER_BIDDINGS_SUCCESS',
  GET_PROVIDER_BIDDINGS_FAILURE = '@market/GET_PROVIDER_BIDDINGS_FAILURE',
  GET_CERTIDOES_REQUEST = '@market/GET_CERTIDOES_REQUEST',
  GET_CERTIDOES_SUCCESS = '@market/GET_CERTIDOES_SUCCESS',
  GET_CERTIDOES_FAILURE = '@market/GET_CERTIDOES_FAILURE',
  GET_RESULTS_REQUEST = '@market/GET_RESULTS_REQUEST',
  GET_RESULTS_SUCCESS = '@market/GET_RESULTS_SUCCESS',
  GET_RESULTS_FAILURE = '@market/GET_RESULTS_FAILURE',
  PRODUCTS_SERVICES_REQUEST = '@market/PRODUCTS_SERVICES_REQUEST',
  PRODUCTS_SERVICES_SUCCESS = '@market/PRODUCTS_SERVICES_SUCCESS',
  PRODUCTS_SERVICES_FAILURE = '@market/PRODUCTS_SERVICES_FAILURE',
  GET_FOLLOWUPS_REQUEST = '@market/GET_FOLLOWUPS_REQUEST',
  GET_FOLLOWUPS_SUCCESS = '@market/GET_FOLLOWUPS_SUCCESS',
  GET_FOLLOWUPS_FAILURE = '@market/GET_FOLLOWUPS_FAILURE',
  GET_RESULT_BIDDING_REQUEST = '@market/GET_RESULT_BIDDING_REQUEST',
  GET_RESULT_BIDDING_SUCCESS = '@market/GET_RESULT_BIDDING_SUCCESS',
  GET_RESULT_BIDDING_FAILURE = '@market/GET_RESULT_BIDDING_FAILURE',
}

export interface FollowupListTypes {
  sintese: string;
  data_fonte: string;
  id: number;
}
export interface FollowupTypes {
  licitacao: {
    id: number;
    created: string;
    modified: string;
    data_validade: string;
    datahora_abertura: string | null;
    datahora_documento: string | null;
    datahora_prazo: string;
    objeto: string;
    edital: string;
    orgao: {
      nome: string;
      cidade: string;
      estado: string;
      acompanhamentos: Array<FollowupListTypes>;
    };
  };
}
export interface ResultTypes {
  id: number;
  item_numero: number;
  fornecedor: string;
  item_descricao: string;
  licitacao_id: number;
  item_quantidade: string;
  item_unidade: string;
  item_valor_unitario: number;
  item_valor_total: number;
  cnpj: string;
}

export interface ResultsTypes {
  licitacao: {
    id: number;
    created: string;
    objeto: string;
    modified: string;
    edital_tem: boolean;
    edital_preco: number;
    tipo_agrupamento_descricao: string;
    processo: string;
    edital: string;
    orgao: {
      nome: string;
      uasg: string;
      endereco: string;
      estado: string;
      cidade: string;
    };
    resultados: Array<ResultTypes>;
    data_validade: string;
  };
}

export interface Results {
  resultados: Array<ResultsTypes>;
  total: number;
}

export interface ProductsTypes {
  id: number;
  item_descricao_detalhado: string;
  item_descricao: string;
  item_valor_total: number;
  item_quantidade: string;
  fornecedor: string;
  objeto: string;
  item_valor_unitario: number;
  item_numero: number;
  item_unidade: string;
  marca_item_ofertado: string;
  fabricante_item_ofertado: string;
  modelo_item_ofertado: string;
}

export interface Products {
  products: Array<ProductsTypes>;
  total: number;
}

export interface FollowupDataTypes {
  created: string;
  data_fonte: string;
  edital: string;
  fonte_id: 3;
  id: number;
  licitacao_id: number;
  modified: string;
  sintese: string;
}

export interface FollowupsTypes {
  licitacao: {
    acompanhamentos: Array<FollowupListTypes>;
    created: string;
    data_validade: string;
    datahora_abertura: string;
    datahora_documento: null | string;
    datahora_prazo: null | string;
    datahora_retirada: null | string;
    datahora_visita: null | string;
    edital: string;
    edital_preco: number;
    edital_tem: boolean;
    id: number;
    itens: string;
    modalidade_id: number;
    modalidade_nome: string;
    modalidade_sigla: string;
    modified: string;
    objeto: string;
    observacao: string;
    orgao: {
      cep: string;
      cidade: string;
      cidade_id: number;
      codigo: string;
      edital_site: string;
      endereco: string;
      estado: string;
      estado_id: number;
      homepage1: string;
      homepage2: string;
      id: number;
      nome: string;
      tipo_orgao: string;
      tipo_orgao_id: 2;
      uasg: string;
    };
    orgao_id: number;
    processo: string;
    resultados: Array<any>;
    tipo_agrupamento_descricao: string;
    tipo_agrupamento_id: number;
    tipo_agrupamento_resumo: string;
  };
}

export interface Followups {
  licitacao: Array<FollowupsTypes>;
  total: number;
}
export interface RangeTypes {
  x: string;
  y: number;
  value: any;
}

export interface ActivitiesTypes {
  nome: string;
  id: number;
  codigo: number;
  updated: string;
}
export interface FiltersTypes {
  description: string;
  updated: string;
  activities: Array<ActivitiesTypes>;
}

export interface MarketData {
  total_entries: number;
  total_investimento: number;
  date_range: Array<RangeTypes>;
  date_range_accumulated: Array<RangeTypes>;
  estados: {
    regions: Array<any>;
  };
  modalities: Array<string>;
  activities: Array<ActivitiesTypes>;
}

export interface FilterTypes {
  filter: {
    id: number;
    client_id: number;
    bidding_filterable_id: number;
    bidding_filterable_type: string;
    created_at: string;
    updated_at: string;
    description: string;
    followup_filterable_id: number;
    last_bulletin_id: number;
    morning: boolean;
    pr_next_issue_offset: number;
    send_all_open: boolean;
    subject_description: boolean;
    night: boolean;
  };
  bidding: {};
}

export interface OrgaoDadosTypes {
  orgao_id: number;
  doc_count: number;
  nome: string;
  uf: string;
  cidade: string | null;
  id: number;
  valor: number;
  licitacao: number;
}

export interface OrgaoTypes {
  total: number;
  total_pages: number;
  results: Array<OrgaoDadosTypes>;
}

export interface ConcorrenteDadosTypes {
  cnpj: number;
  razao_social: string;
  total_results: number;
  valor_total: number;
}

export interface ConcorrentesTypes {
  total: number;
  total_pages: number;
  results: Array<ConcorrenteDadosTypes>;
}

export interface BiddingTypes {
  licitacao: {
    atividade: string;
    created: string;
    data_validade: string;
    datahora_abertura: string;
    datahora_documento: null;
    datahora_prazo: null;
    datahora_retirada: null;
    datahora_visita: null;
    edital: string;
    edital_preco: number;
    edital_tem: true;
    id: number;
    itens: string;
    modalidade_id: number;
    modalidade_nome: string;
    modalidade_sigla: string;
    modified: string;
    objeto: string;
    observacao: string;
    orgao: {
      id: number;
      codigo: string;
      nome: string;
      orgao_id: number;
      processo: string;
      tipo_agrupamento_descricao: string;
      tipo_agrupamento_id: number;
      tipo_agrupamento_resumo: string;
    };
  };
}

export interface BuyerTypes {
  cep: string;
  cidade: string;
  edital_site: string;
  endereco: string;
  estado: string;
  nome: string;
  uasg: string;
  licitacoes: Array<BiddingTypes>;
}

export interface CompanyPartnersTypes {
  codigo_vinculo: number;
  descricao_vinculo: string;
  empresa_id: number;
  id: number;
  nome: string;
}

export interface CnaesTypes {
  descricao: string;
  id: number;
  codigo: string;
}
export interface GetBiddingsTypes {
  _source: {
    licitacao_id: number;
    item_descricao: string;
    item_quantidade: string;
    item_valor_unitario: number;
    item_valor_total: number;
  };
}

export interface SancoesTypes {
  id: number;
  category: string;
  portal: string;
  orgao_sancionador: string;
  penalty_start_date: string;
  penalty_end_date: string;
  available: boolean;
  url: string;
}

export interface CertidoesTypes {
  ufSancionado: string;
  orgao: string;
  categoriaSancao: string;
  dataInicialSancao: string;
  dataFinalSancao: string;
  dataPublicacao: string;
}

export interface CompanyTypes {
  id: number;
  razao_social: string;
  logradouro: string;
  numero: string;
  bairro: string;
  municipio: string;
  uf: string;
  telefone: string;
  cnpj: string;
  email: string;
  situacao: string;
  tipo_empresa: string;
  natureza_juridica: string;
  abertura: string;
  quadro_socios_administradores: Array<CompanyPartnersTypes>;
  capital_social: number;
  cnaes: Array<CnaesTypes>;
  biddings: Array<GetBiddingsTypes>;
  total_result: number;
  sancoes: Array<SancoesTypes>;
  certidoes: Array<CertidoesTypes>;
}

export interface EdictsTypes {
  filename: string;
  url: string;
}

export interface ResultsBiddingTypes {
  cnpj: number;
  codigo_site: string;
  fabricante_item_ofertado: null;
  fornecedor: string;
  id: number;
  item_descricao: string;
  item_descricao_detalhado: null;
  item_numero: string;
  item_quantidade: string;
  item_unidade: string;
  item_valor_total: number;
  item_valor_unitario: number;
  licitacao_id: number;
  marca_item_ofertado: null;
  modelo_item_ofertado: null;
  portal_id: number;
}

export interface BiddingsTypes {
  edital: string;
  edital_status_id: number | null;
  id: number;
  objeto: string;
  observacao: string;
  processo: string;
  situacao: string;
  edicts: Array<EdictsTypes>;
  datas: {
    datahora_abertura: string | null;
    datahora_documento: string | null;
    datahora_prazo: string | null;
    datahora_retirada: string | null;
    datahora_visita: string | null;
  };
}
export interface BiddingResultTypes {
  licitacao: BiddingsTypes;
  orgao: {
    site: string;
    endereco: string;
    cidade_uf: string;
    uasg: string;
    nome: string;
  };
  resultados: Array<ResultsBiddingTypes>;
  acompanhamentos: Array<FollowupListTypes>;
}

export interface RequestState {
  search: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_filters: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  search_buyers: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  search_providers: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  filter_options: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_public_body: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_bidding: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_company: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_provider_biddings: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_certidoes: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_results: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_products: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_followups: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  bidding_result: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface MarketState {
  readonly market: MarketData;
  readonly get_filters: Array<FilterTypes>;
  readonly orgao: OrgaoTypes;
  readonly concorrentes: ConcorrentesTypes;
  readonly buyer: BuyerTypes;
  readonly company: CompanyTypes;
  readonly resultado: Results;
  readonly products_services: Products;
  readonly bidding_result: BiddingResultTypes;
  readonly bidding: Followups;
  readonly request: RequestState;
}
